"use client";

import type { ComponentProps } from "react";
import { analyticsTrack } from "@/analytics/analytics";
import { Link } from "@/i18n/navigation";

export function LandingCtaLink(props: ComponentProps<typeof Link>) {
	return (
		<Link
			{...props}
			onClick={(event) => {
				props.onClick?.(event);
				if (event.defaultPrevented) return;
				analyticsTrack({
					eventName: "editor_entry_clicked",
					properties: {
						surface: "landing_bottom",
						destination: "/projects",
					},
				});
			}}
		/>
	);
}
